angular.module('TetherApp').factory('modelLockService', [
    '$q',
    '$http',
    function ($q, $http) {

        let self = this;

        let time = function (data) {
            let uri = '/api/v1/model-lock/time';
            return $http.post(uri, data, {
                cache: false,
                headers: {'Cache-Control': 'no-cache'}
            }).then(function (response) {
                return response.data;
            });
        };

        let lock = function (data) {
            let uri = '/api/v1/model-lock';
            return $http.post(uri, data, {
                cache: false,
                headers: {'Cache-Control': 'no-cache'}
            }).then(function (response) {
                return response.data;
            });
        };

        let extend = function (data) {
            let uri = '/api/v1/model-lock/extend';
            return  $http.post(uri, data, {
                cache: false,
                headers: {'Cache-Control': 'no-cache'}
            }).then(function (response) {
                return response.data;
            });
        }

        let release = function (data) {
            let uri = '/api/v1/model-lock/release';
            return  $http.post(uri, data, {
                cache: false,
                headers: {'Cache-Control': 'no-cache'}
            }).then(function (response) {
                return response.data;
            });
        }

        return {
            time: time,
            lock: lock,
            extend: extend,
            release: release
        };

    }
]);
